import GridChart from "../../../components/Chart/GridChart";

const HOTEL_DASH = [
  {
    id: "occupancy",
    title: "hotel_occupancy",
    type: "bar",
    method: "get_hotel_occupancy",
    colspan: 6,
  },
  {
    id: "revenue",
    title: "hotel_revenue",
    type: "line",
    method: "get_hotel_revenue",
    colspan: 6,
  },
  {
    id: "guests",
    title: "hotel_guests",
    type: "pie",
    method: "get_hotel_guests",
    colspan: 12,
  },
];

function HotelDash() {
  return (
    <div className="p-6 w-full">
      <GridChart accReports={HOTEL_DASH} />
    </div>
  );
}

export default HotelDash;
